// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h8-6";
export var emphasizeQuantity = "_h8-3";
export var flatBottomCorners = "_h8-5";
export var productImage = "_h8-0";
export var quantityContainer = "_h8-2";
export var tooltip = "_h8-1";
export var wrapAndEllipsesOverflow = "_h8-4";